import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { TbArrowBackUp, TbChevronLeft } from "react-icons/tb";

const BanksLedgerHeader = ({ status, selectedMonth, onMonthChange }) => {
  const getBadgeStyle = () => {
    switch (status) {
      case "paid":
        return {
          bg: "#dcfce7",
          color: "#15803d",
          text: "Paid",
          border: "1px solid #bbf7d0",
        };
      case "partial":
        return {
          bg: "#fef9c3",
          color: "#a16207",
          text: "Partially Paid",
          border: "1px solid #fef08a",
        };
      case "pending":
      default:
        return {
          bg: "#fee2e2",
          color: "#b91c1c",
          text: "Pending",
          border: "1px solid #fecaca",
        };
    }
  };

  const badge = getBadgeStyle();

  return (
    <motion.div className="header" style={{ padding: "0 16px" }}>
      {/* Left: Back Link */}
      <div
        style={{
          // width: "140px",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <Link to="/analytics" className="headerLink" style={{ width: "auto" }}>
          <TbChevronLeft className="icoAdjust" size={24} />
        </Link>
        <div
          style={{
            backgroundColor: badge.bg,
            color: badge.color,
            border: badge.border,
            padding: "4px 14px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 700,
            letterSpacing: "0.2px",
            lineHeight: 1.2,
          }}
        >
          {badge.text}
        </div>
      </div>

      {/* Right: Compact Month Picker */}
      <div
        style={{
          width: "140px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <input
          type="month"
          value={selectedMonth}
          onChange={(e) => onMonthChange(e.target.value)}
          style={{
            padding: "3px 8px",
            borderRadius: "16px",
            border: "1px solid #cbd5e1",
            fontSize: "12px",
            outline: "none",
            backgroundColor: "#f8fafc",
            color: "#334155",
            fontWeight: 600,
            cursor: "pointer",
            width: "125px",
          }}
        />
      </div>
    </motion.div>
  );
};

export default BanksLedgerHeader;
